var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, updateData, } from "../dataAccess";
// Get all sites
export const getSiteContent = (id, name, includeArchived) => __awaiter(void 0, void 0, void 0, function* () {
    let url = `SiteContent`;
    if (id) {
        url = url + `?id=${id}`;
    }
    if (name) {
        url = url + `?name=${name}`;
    }
    if (includeArchived) {
        let prefix = id || name ? '&' : '?';
        url = url + prefix + `includeArchived=true`;
    }
    return getData(url);
});
// Update an existing site
export const updateSiteContent = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `SiteContent/update`;
    return updateData(url, item);
});
